import Form from "antd/lib/form";
import React, { useState } from "react";
import Terms from "../Terms";
import { useEffect } from "react";
import { getImageBaseUrl } from "../../services/s3-utils";
import check from "../../assets/white-check.svg";
import QalortButton from "../Button";
import { notification } from "antd";

function Step1({ setCurrStep, fields, set_user_type, user_type, loading }) {
  const [signupForm] = Form.useForm();
  const [pwrdType, setPwrdType] = useState(true);
  const userTypes = [
    {
      title: "Mentor",
      value: "instructor",
    },
    {
      title: "Mentee",
      value: "learner",
    },
  ];

  return (
    <>
      <Form
        form={signupForm}
        defaultValue={fields}
        name="normal_login"
        layout="vertical"
        className="login-form mt3"
        onFinish={(e) => {
          if (!user_type) {
            notification.error({ description: "Please select a user type" });
            return;
          }
          setCurrStep(e);
        }}
      >
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="w-full">
            <p className="label mb-1 text-main">First Name</p>

            <Form.Item
              name="first_name"
              className="!mb-0"
              rules={[
                {
                  required: true,
                  message: "Please input your First Name!",
                },
              ]}
            >
              <input
                defaultValue={fields.first_name}
                value={fields.first_name}
                id="first_name_input"
                className="main-input h-12 rounded-md w-full focus:outline-none px-3"
              />
            </Form.Item>
          </div>
          <div className="w-full">
            <p className="label mb-1 text-main">Last Name</p>
            <Form.Item
              name="last_name"
              className="!mb-0"
              rules={[
                {
                  required: true,
                  message: "Please input your Last Name!",
                },
              ]}
            >
              <input
                id="last_name_input"
                defaultValue={fields.last_name}
                value={fields.last_name}
                className="main-input h-12 rounded-md w-full focus:outline-none px-3"
              />
            </Form.Item>
          </div>
        </div>
        <div className="w-full mt-5">
          <p className="label mb-1 text-main">Email Address</p>
          <Form.Item
            name="email"
            className="!mb-0"
            rules={[
              {
                required: true,
                message: "Please input your Email address!",
              },
            ]}
          >
            <input
              id="email_input"
              defaultValue={fields.email}
              value={fields.email}
              className="main-input h-12 rounded-md w-full focus:outline-none px-3"
            />
          </Form.Item>
        </div>
        <div className="w-full mt-5">
          <p className="label mb-1 text-main">Password</p>
          <div className="flex relative w-full">
            <Form.Item
              className="w-full !mb-0"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your Password!",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters",
                },
                {
                  pattern: /(?=.*[0-9])(?=.*[a-zA-Z])/,
                  message:
                    "Password must contain at least one letter and one number",
                },
                {
                  pattern: /(?=.*[!@#$%^&*])/,
                  message:
                    "Password must contain at least one special character",
                },
              ]}
            >
              <input
                id="password_input"
                defaultValue={fields.password}
                value={fields.password}
                type={pwrdType ? "password" : "text"}
                className="absolute left-0 top-0 z-10 w-full main-input h-12 rounded-md focus:outline-none px-3"
              />
            </Form.Item>
            <img
              onClick={() => setPwrdType(!pwrdType)}
              src={`${getImageBaseUrl}/assets/eye.svg`}
              className="absolute top-3 right-4 pointer z-20"
              alt=""
            />
          </div>
        </div>

        <p className="mt-12 p-xs text-main">
          Who do you want to be on Qalort? 😄
        </p>
        <div className="w-full grid grid-cols-2 gap-4 items-center">
          {userTypes.map((type) => {
            const typeSelected = user_type === type.value;
            return (
              <div
                id={
                  type.value === "instructor" ? "instructor_box" : "learner_box"
                }
                onClick={() => set_user_type(type.value)}
                className={`pointer`}
              >
                <div
                  id="instructor_box_inner"
                  className={`${
                    typeSelected
                      ? "bg-pri border-pri bw-2"
                      : "border-[#EFEFF5] bg-[#EFEFF5]"
                  }  rounded-md p-4 [@media(max-width:600px)]:p-4 [@media(max-width:600px)]:h-32 w-full flex items-center justify-between`}
                >
                  <p
                    className={`mb-0 text-[16px] ${
                      typeSelected ? "text-white" : "text-[#515156]"
                    }`}
                  >
                    {type.title}
                  </p>
                  {typeSelected ? (
                    <img src={check} className="w-6" alt="" />
                  ) : (
                    <div className="w-6 h-6 rounded-full border-[1px] border-[#000000]"></div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <Terms />
        <QalortButton
          id="next_button"
          htmlType="submit"
          className="bg-pri px-5 py-3 rounded-lg text-white w-full mt-4"
          loading={loading}
        >
          Submit
        </QalortButton>
      </Form>
      {/* <SocialAuth /> */}
    </>
  );
}

export default Step1;
